import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContactUsProfileService {

  constructor(private http: HttpClient) { }

  getAll(params) {
    return this.http.get<any>(`/salary_survey/api/site/contact-us`, { params: params })
      .pipe(map(data => {
        return data;
      }));
  }

  getContactFlag() {
    return this.http.get<any>(`/salary_survey/api/site/is_ss_Contact_enabled`)
      .pipe(map(data => {
        return data;
      }));
  }

  createContactForm(data) {
    return this.http.post<any>(`/salary_survey/api/mail_history`, data)
      .pipe(map(res => {
        console.log(res, 'res')
        return res;
      }));
  }
}
